<template>
  <vs-table hover-flat v-if="projects && projects.length" :data="projects">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('name')"></vs-th>
      <vs-th v-text="$t('assigned_to')"></vs-th>
      <vs-th class="text-center" v-text="$t('status')"></vs-th>
      <vs-th v-text="$tc('link', 2)"></vs-th>
      <vs-th class="text-center" v-text="$t('function')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
        <vs-td v-text="tr.name" :data-tr-title="$t('name')"></vs-td>
        <vs-td :data-tr-title="$t('assigned_to')">
          <ul v-if="tr.users">
            <li v-for="(user, index) in tr.users" :key="index" v-text="user.name"></li>
          </ul>
          <span v-else>--</span>
        </vs-td>
        <vs-td class="text-center text-left-on-mobile" :data-tr-title="$t('status')">
          <badge-status :content="tr.status.name" :status="tr.status.id"></badge-status>
        </vs-td>
        <vs-td :data-tr-title="$tc('link', 2)">
          <ul v-if="tr.links">
            <badge-clipboard v-for="(item, key) in tr.links" :key="key" :text="item.url"></badge-clipboard>
          </ul>
          <span v-else>--</span>
        </vs-td>
        <vs-td>
          <div class="flex justify-center">
            <vs-button color="primary" type="border" icon-pack="feather" icon="icon-edit" size="small" @click.prevent="$emit('customClickEdit', tr.id)"></vs-button>&nbsp;
            <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small" @click.prevent="$emit('customClickDelete', tr.id)"></vs-button>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
import BadgeStatus from '@/components/badge/Status'

export default {
  name: 'Shared.Projects.List',
  components: {
    BadgeStatus
  },
  props: {
    projects: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style scoped>

</style>
